import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts'

interface NodeHealthGaugeProps {
  score: number
  size?: number
}

export function NodeHealthGauge({ score, size = 120 }: NodeHealthGaugeProps) {
  const percentage = Math.round(score * 100)
  const data = [
    { value: percentage },
    { value: 100 - percentage },
  ]

  const getColor = (score: number) => {
    if (score >= 0.8) return 'hsl(142.1 76.2% 36.3%)' // green
    if (score >= 0.5) return 'hsl(47.9 95.8% 53.1%)' // yellow
    return 'hsl(0 84.2% 60.2%)' // red
  }

  return (
    <div className="relative" style={{ width: size, height: size }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            startAngle={180}
            endAngle={0}
            innerRadius="60%"
            outerRadius="80%"
            paddingAngle={0}
            dataKey="value"
          >
            <Cell fill={getColor(score)} />
            <Cell fill="hsl(var(--muted))" />
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="text-2xl font-bold">{percentage}%</span>
      </div>
    </div>
  )
}
